import type { CustomerSummary } from "../../../services/whatsapp/whatsappService";
import StatusBadge from "./StatusBadge";

interface CustomerCardProps {
  customer: CustomerSummary;
  isSelected: boolean;
  onClick: () => void;
}

const CustomerCard = ({ customer, isSelected, onClick }: CustomerCardProps) => {
  const displayName = customer.display_name || customer.customer_name || customer.customer_phone;
  const initial = displayName?.[0]?.toUpperCase() || "?";
  const timeStr = customer.latest_created_at
    ? new Date(customer.latest_created_at).toLocaleDateString([], {
        day: "2-digit",
        month: "short",
      })
    : "";

  return (
    <div
      onClick={onClick}
      className={`flex items-center gap-3 px-4 py-3 cursor-pointer border-b border-gray-100 transition-colors ${
        isSelected
          ? "bg-[#EBEEFF] border-l-2 border-l-[#5050EA]"
          : "hover:bg-gray-50"
      }`}
    >
      <div className="w-10 h-10 rounded-full bg-[#5050EA] flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
        {initial}
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between">
          <span className="font-semibold text-sm truncate">{displayName}</span>
          <span className="text-xs text-gray-400 flex-shrink-0 ml-2">{timeStr}</span>
        </div>
        <div className="flex items-center justify-between mt-1">
          <span className="text-xs text-gray-500">
            {customer.order_count} {customer.order_count === 1 ? "pedido" : "pedidos"}
          </span>
          {/* <StatusBadge status={customer.latest_status} /> */}
        </div>
      </div>
    </div>
  );
};

export default CustomerCard;
